module.exports = __webpack_public_path__ + "static/media/link-viola.f25c3f26.svg";